export default __webpack_public_path__ + "static/media/earn.80d50c6b.svg";